import { observer } from 'mobx-react';
import { CloseAction } from './UseOpenable';
import CloseIcon from '../../Cutesies/CloseIcon';

interface ModalCloseButtonProps {
  className?: string;
  close: CloseAction;
  label: string;
}

function ModalCloseButton({ className, close, label }: ModalCloseButtonProps) {
  return (
    <button
      className="float-right outline-0 bg-none border-none cursor-pointer"
      onClick={close}
      data-test-close-button={true}
      data-intercom-target="close-modal-button"
      aria-label={label}
      role="button"
      autoFocus
    >
      <CloseIcon />
    </button>
  );
}

export default observer(ModalCloseButton);
